export class SidebarDownloadType {
    readonly formText: string
    readonly submittedText: string

    static CatalogExport = Object.freeze(
        new SidebarDownloadType(
            'Select the file type you would that you would like to download your catalog in.',
            "We're preparing your files for download. You'll receive an email with " +
                'your downloadable catalog export.'
        )
    )

    static SongwriterCatalogExport = Object.freeze(
        new SidebarDownloadType(
            'Select the format and file type you would like to use to download your song catalog.',
            "We're preparing your files for download. Once they're ready, you'll receive an email with " +
                'a link to download your full catalog export.'
        )
    )

    static OverclaimExport = Object.freeze(
        new SidebarDownloadType(
            'Select the file type you would that you would like to download your overclaim history in.',
            "We're preparing your files for download. You'll receive an email with " +
                'your downloadable overclaim history export.'
        )
    )

    static MatchedRecordingsExport = Object.freeze(
        new SidebarDownloadType(
            'Select the file type you would that you would like to download your matched recordings in.',
            "We're preparing your files for download. You'll receive an email shortly with " +
                'your downloadable matched recordings extract'
        )
    )

    static MatchHistoryExport = Object.freeze(
        new SidebarDownloadType(
            'Select the file type you would that you would like to download your match history in.',
            "We're preparing your files for download. You'll receive an email shortly with " +
                'your downloadable match history extract'
        )
    )

    static RoyaltyStatements = Object.freeze(
        new SidebarDownloadType(
            'Select the format and file type that you would like ' + 'to download your statements in.',
            "We're preparing your files for download. " +
                "You'll receive an email shortly with downloadable statements."
        )
    )

    static RegistrationHistoryExport = Object.freeze(
        new SidebarDownloadType(
            '',
            "We're preparing your files for download. When the files are ready, you'll receive an email with your downloadable registration history export."
        )
    )

    private constructor(formText: string, submittedText: string) {
        this.formText = formText
        this.submittedText = submittedText
    }
}
